import { Comment } from "../../../../../models";

export const UPDATE_LATEST_COMMENT = 'UPDATE_LATEST_COMMENT'

export interface UpdateLatestCommentAction {
    type: string
    docId: string
    comment: Comment
}
export const updateLatestComment = (docId: string, comment: Comment): UpdateLatestCommentAction => ({
    type: UPDATE_LATEST_COMMENT,
    docId,
    comment
})
